@if (buildingsDatasource) {
    <app-server-side-grid
        [colDefs]="gridColumns"
        [datasource]="buildingsDatasource"
        [appliedSort]="appliedSort"
        [noRows]="noResults()"
        [titleNoData]="'No Buildings available.'"
        (cellSorting)="onSortChanged($event)"
    >
    </app-server-side-grid>
}
